import { Injectable, signal } from '@angular/core';
import { SearchType } from '../enums/search-type';
import { AnswerSearch } from '../models/recent-search';

export interface SearchPanelDrawerState {
  open: boolean;
  searchType?: SearchType;
  items: AnswerSearch[];
  showAll?: boolean;
  showAllResults?: boolean;
  showSearchPanel?: boolean;
  isShowAllResults?: boolean;
}

@Injectable({ providedIn: 'root' })
export class DrawerSearchPanelService {
  width = signal(350);
  selectedPromptText = signal<string | null>(null);
  lastSentText = signal<string>('');
  private _state = signal<SearchPanelDrawerState>({
    open: false,
    items: [],
    showAll: false,
    showAllResults: false,
    showSearchPanel: true,
    isShowAllResults: false,
  });

  state = this._state.asReadonly();

  open(config: Partial<SearchPanelDrawerState>) {
    this._state.update(s => ({
      ...s,
      open: config.open ?? true,
      showSearchPanel: config.showSearchPanel ?? true,
      showAll: config.showAll ?? false,
      showAllResults: config.showAllResults ?? false,
      isShowAllResults: config.isShowAllResults ?? false,
      searchType: config.searchType,
      items: config.items ?? s.items,
    }));
  }

  patch(config: Partial<SearchPanelDrawerState>) {
    this._state.update(s => ({ ...s, ...config }));
  }

  setItems(items: AnswerSearch[]) {
    this._state.update(s => ({ ...s, items }));
  }

  close() {
    this._state.update(s => ({ ...s, open: false }));
  }
}
